class SystemAdminUsers {
  static SystemAdminUsers_Endpoints = (id) => ({
    list: 'users',
    getUserId: `users/${id}`,
    resetPasswordRequest: `users/${id}/reset-password/request`,
  })
}

export default SystemAdminUsers
